import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  hover = false
}: CardProps) {
  return <motion.div className={`relative overflow-hidden rounded-2xl bg-night-800/50 border border-white/5 backdrop-blur-sm p-8 ${className}`} whileHover={hover ? {
    y: -5,
    boxShadow: '0 10px 30px -10px rgba(0,0,0,0.5)'
  } : {}} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5
  }} data-id="element-121">
      {/* Grain texture overlay */}
      <div className="absolute inset-0 bg-grain opacity-20 pointer-events-none z-0 mix-blend-overlay" data-id="element-122"></div>

      {/* Content */}
      <div className="relative z-10" data-id="element-123">{children}</div>
    </motion.div>;
}